import { makeAutoObservable } from 'mobx'

class GlobalEventsRegistry {
  private _fullEventsCount = 0

  constructor() {
    makeAutoObservable(this)
  }

  registerFullEvents = () => {
    this._fullEventsCount += 1
  }

  unregisterFullEvents = () => {
    this._fullEventsCount -= 1
  }

  get hasFullEvents() {
    return this._fullEventsCount > 0
  }
}

export const globalEventsRegistry = new GlobalEventsRegistry()
